var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDateEditIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 1H9V0H11V1H12.5C13.3284 1 14 1.67157 14 2.5V10.5C14 11.3284 13.3284 12 12.5 12H1.5C0.671573 12 0 11.3284 0 10.5V2.5C0 1.67157 0.671573 1 1.5 1H3V0H5V1ZM1.5 10.5H12.5V5.75H1.5V10.5ZM10.5996 6.59961C11.0414 6.59961 11.3994 6.95856 11.3994 7.40039V8.59961C11.3994 9.04144 11.0414 9.40039 10.5996 9.40039H9.39941C8.95768 9.40029 8.59961 9.04137 8.59961 8.59961V7.40039C8.59961 6.95863 8.95768 6.59971 9.39941 6.59961H10.5996ZM1.5 4.25H12.5V2.5H11V3H9V2.5H5V3H3V2.5H1.5V4.25Z",
    fill: "#33333F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateEditIcon);
export default __webpack_public_path__ + "static/media/date-edit-icon.b007720596092a1af67b9c8ca1a2345f.svg";
export { ForwardRef as ReactComponent };